import { RefObject, useRef } from "react";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { UseSelectStoreParams } from "./types";

export const useSelectStore = ({
  overrideModalRef
}: {
  overrideModalRef?: RefObject<IModalRefProps>;
}): UseSelectStoreParams => {
  const modalRef = useRef<IModalRefProps>(null);

  const modalRefToUse = overrideModalRef || modalRef;

  const handleOnSelectStore = () => {
    if (modalRefToUse) {
      modalRefToUse.current?.open();
    }
  };

  return {
    modalRef: modalRefToUse,
    handleOnSelectStore
  };
};
